const routes = {
    HOME: '/',
    LOGIN: '/iniciar-sesion',
    PAYMENT_CREATE: '/nuevo-pago',
    PAYMENT_CHECKOUT: '/finalizar-pagos',
    PAYMENT_CHECKOUT_ONLINE: lotId => (
      `/finalizar-pagos/${lotId}/pago-online`
    ),
    PAYMENT_CHECKOUT_CANCEL: '/finalizar-pagos/cancelar'
  };
  
export default routes;  